import { useSelector } from 'react-redux';
import { selectIsPartnerUser } from '@redux/reducers/slices/user';
import { useGetPartner } from '@services/api/partners';
import { Stack, Typography } from '@mui/material';
import { PartnerPictureAvatar } from '@components/Avatars/PartnerPictureAvatar';

export const PartnerProfile = () => {
  const isUserPartner = useSelector(selectIsPartnerUser);
  const { partner } = useGetPartner();

  if (!isUserPartner) {
    return null;
  }

  return (
    <Stack direction="row" justifyContent="end" alignItems="center" spacing={2} ml={1}>
      <PartnerPictureAvatar whiteBackground />
      <Typography variant="h4">{partner?.name}</Typography>
    </Stack>
  );
};
